export default {
  header: "It's time.",
  view: "drawing",
  monster: {}
};
